import React from 'react';
import { Card, CardContent, Button } from '@mui/material';
import './PricingPlans.css';
import pricing_checkmark from '../../assets/images/pricing_chechkmark.svg';

const plans = [
	{
		title: 'Free',
		yearlyPrice: '$0',
		biWeeklyPrice: '$0',
		description: <div style={{marginBottom: '1.5rem'}}>Get started with +EV betting, risk-free. <br/></div>,
		features: [
			'20 second refresh',
			'View top play',
			'Compare odds across sportsbooks',
			'Pregame plays only',
			'Up to 5 sportsbooks',
			'Up to 3 leagues',
			'WagerWiz sharp combo',
			'One-click bet links',
			'Tag placed bets',
			'Line history graphs',
		],
	},
	{
		title: 'Basic',
		yearlyPriceDiscounted: '$899',
		biWeeklyPriceDiscounted: '$31.99',
		yearlyPrice: '$999',
		biWeeklyPrice: '$39.99',
		description: (
			<>
				Serious tools for serious bettors.
			</>
		),
		features: [
			'2-3 second refresh',
			'View all plays',
			'Compare odds across sportsbooks',
			'Pregame plays only',
			'Up to 5 sportsbooks',
			'Up to 2 leagues',
			'WagerWiz sharp combo',
			'One-click bet links',
		],
	},
	{
		title: '💎 Plus',
		yearlyPriceDiscounted: '$1199',
		biWeeklyPriceDiscounted: '$39.99',
		yearlyPrice: '$1099',
		biWeeklyPrice: '$49.99',
		description: 'Maximize EV. Minimize missed opportunities.',
		features: [
			'2-3 second refresh',
			'View all plays',
			'Compare odds across sportsbooks',
			'Pregame & live plays',
			'Unlimited sportsbooks',
			'Unlimited leagues',
			'Custom sharp books',
			'One-click bet links',
			'Auto-refresh plays',
			'Tag placed bets',
		],
	},
	{
		title: '👑 Premium',
		yearlyPriceDiscounted: '$1499',
		biWeeklyPriceDiscounted: '$55.99',
		yearlyPrice: '$1599',
		biWeeklyPrice: '$69.99',
		description: 'Maximize EV. Minimize missed opportunities.',
		features: [
			'2-3 second refresh',
			'View all plays',
			'Compare odds across sportsbooks',
			'Pregame & live plays',
			'Unlimited sportsbooks',
			'Unlimited leagues',
			'Custom sharp books',
			'One-click bet links',
			'Auto-refresh plays',
			'Tag placed bets',
			'Line history graphs',
			'New play notifications',
			'Beta access to new tools',
			'VIP support',
		],
	},
];

export const PricingPlans = (props) => {
	const { paymentCycle } = props;

	return (
		<div className="flex justify-center min-h-screen bg-gray-900 text-white p-4">
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
				{plans.map((plan) => {
					let price;
					let pricePhrase = '';
					if (paymentCycle === 'BiWeekly') {
						price = plan.biWeeklyPrice;
						pricePhrase = (
							<>
								every <br /> 2 weeks
							</>
						);
					} else {
						price = plan.yearlyPrice;
						pricePhrase = 'per year';
					}
					return (
						<Card
							sx={{
								// height: "570px",
								backgroundColor: '#17191d !important',
								color: 'white',
								border: '1px solid #22262e',
								maxWidth: 255
							}}
							key={plan.title}
							className="bg-gray-800 rounded-2xl shadow-xl p-6 w-80">
							<CardContent>
								<h2 className="text-xl font-bold mb-2">{plan.title}</h2>
								<div className="flex flex-row">
									<p className="text-4xl font-extrabold mb-2">{price}</p>
									<p className="ml-2" style={{ fontSize: 13, opacity: 0.7, alignContent: 'center' }}>
										{pricePhrase}
									</p>
								</div>
								<p className="text-gray-400 mb-4">{plan.description}</p>
								<Button
									style={{ backgroundColor: '#0b63f4', color: 'white', cursor: 'pointer', maxWidth: 200 }}
									className="bg-blue-600 hover:bg-blue-700 text-white font-semibold w-full py-2 rounded-lg mb-4 select-plan-button cursor-pointer">
									Select plan
								</Button>
								<h3 className="text-lg font-semibold mb-2 mt-2">Features</h3>
								<ul className="space-y-2">
									{plan.features.map((feature) => (
										<li key={feature} className="flex items-center space-x-2">
											<img src={pricing_checkmark} alt="checkmark" />
											<span>{feature}</span>
										</li>
									))}
								</ul>
							</CardContent>
						</Card>
					);
				})}
			</div>
		</div>
	);
};
